<template>
  <div>
    <div class="d-flex align-items-center mb-2" v-if="isLoading">
      <div class="w-100">
        <b-progress
        :value="progress"
        max="100"
        show-progress
        striped
        variant="success"
        class="progress-bar-success"
      />
      </div>
    </div>
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <h5>Sutün Seç</h5>
      </div>
      <v-select
        v-model="selected"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        multiple
        label="title"
        :options="option"
      />
      <div class="mt-1 d-flex justify-content-between">
          <!-- button -->
          <b-button
            size="sm"
            variant="danger"
            class="mr-1"
            @click="handleCancel"
          >
            İptal
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="startDownload"
            :disabled="isLoading"
          >
            {{ isLoading ? 'Dosya Hazırlanıyor...' : 'İndir' }}
          </b-button>
        </div>
    </div>
    
  </div>
</template>
<script>
import {
    BProgress,
    BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axiosIns from '@/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// Stil desteği için 'xlsx-js-style' veya benzeri bir kütüphane kullandığınızı varsayıyorum.
// Eğer standart 'xlsx' kullanıyorsanız, stiller (renk, font, hizalama) çalışmayacaktır.
import * as XLSX from 'xlsx'; 
import { tileLayer } from 'leaflet';
import { is } from 'vee-validate/dist/rules';
// VEYA: import XLSX from 'xlsx-js-style'; // Eğer bu kütüphaneyi kullanıyorsanız importu bu şekilde değiştirin.


export default {
    components: {
        BProgress,
        BButton,
        vSelect,
    },
    data() {
        return {
            isLoading: false,
            progress: 0,
            error: null,
            reportType: this.$route.params.type || null,
            // Varsayılan seçilen sütunlar: Özet raporda sadece Fenomen Adı ve Toplamlar olduğu için bu listeden Fenomen Adı, Link Sayısı ve Toplamlar çekilecektir.
            selected: [
                { title: 'Tıklanma (Event)' },
                { title: 'Sepet (Cart)' },
                { title: 'Sipariş (Order)' },
                { title: 'Toplam Satış' },
            ],
            // Tüm link seçenekleri (Detay rapor için)
            option: [
                { title: 'Paylaşım Link' },
                { title: 'Oluşturulma Tarihi' },
                { title: 'Platform' },
                { title: 'Kısa Kod' },
                { title: 'Tıklanma (Event)' },
                { title: 'Sepet (Cart)' },
                { title: 'Sipariş (Order)' },
                { title: 'Toplam Satış' },
            ],
            // API'den dönen anahtar isimleri
            linkExcelColumnMap: {
                'Paylaşım Link': 'link',
                'Oluşturulma Tarihi': 'created_date',
                'Platform': 'platform_name',
                'Kısa Kod': 'short_code',
                'Tıklanma (Event)': 'event_count',
                'Sepet (Cart)': 'cart_count',
                'Sipariş (Order)': 'order_count',
                'Toplam Satış': 'total_amount',
            }
        }
    },
    props: {
        rangeDateProps: {
            type: Object,
            required: false,
            default: () => ({ start_date: null, end_date: null })
        },
        excelTitle: {
            type: String,
            required: false,
        },
    },
    methods: {
        handleCancel() {
            this.$emit('popoverShow', false);
        },

        // Tarih formatlama yardımcı fonksiyonu (YYYY-MM-DD -> DD Ay YYYY)
        formatDateForHeader(dateString) {
            if (!dateString) return 'Belirtilmemiş Tarih';
            try {
                const date = new Date(dateString);
                return new Intl.DateTimeFormat('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' }).format(date);
            } catch (e) {
                return dateString;
            }
        },

        // Sayfa 1: Özet Raporu Oluşturma
        formatTurkishCurrency(value) {
            if (value === null || value === undefined || isNaN(value)) return "0,00";
            // Türkçe locale (tr-TR) kullanarak formatla. Bu, nokta binlik, virgül ondalık yapar.
            return new Intl.NumberFormat('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                useGrouping: true // Binlik ayırıcı kullan
            }).format(value)+" TL";
        },

        parseTurkishCurrency(value) {
            if (!value || typeof value !== 'string') return 0;
            // 1. Noktaları (binlik ayracı) kaldır: "67462,14"
            let cleanedValue = value.replace(/\./g, '');
            // 2. Virgülü (ondalık ayracı) noktaya çevir: "67462.14"
            cleanedValue = cleanedValue.replace(',', '.');
            // 3. Float sayıya çevir.
            return parseFloat(cleanedValue) || 0;
        },

        // Sayfa 1: Özet Raporu Oluşturma
        createSummarySheet(groupedLinks) {
            const summaryHeaders = [
                'Fenomen Adı/Soyadı', 'Link Sayısı', 'Toplam Tıklanma (Event)', 
                'Toplam Sepet (Cart)', 'Toplam Sipariş (Order)', 'Toplam Satış Tutarı (TL)'
            ];

            const startDateStr = this.formatDateForHeader(this.rangeDateProps.start_date);
            const endDateStr = this.formatDateForHeader(this.rangeDateProps.end_date);
            const mainHeaderTitle = `${startDateStr} - ${endDateStr} Tarihleri Arasındaki Fenomen Analizi`;

            const finalData = [ [mainHeaderTitle], summaryHeaders ];

            let grandTotalLinks = 0;
            let grandTotalEvents = 0;
            let grandTotalCarts = 0;
            let grandTotalOrders = 0;
            let grandTotalAmount = 0; // Bu bir sayı olacak

            groupedLinks.forEach(group => {
                const linksCount = Number(group.total_links_count) || 0;
                const eventCount = Number(group.total_event_count) || 0;
                const cartCount = Number(group.total_cart_count) || 0;
                const orderCount = Number(group.total_order_count) || 0;
                
                // --- GÜNCELLEME: Toplam Satış Tutarını linklerden hesapla ---
                let amountSum = 0; // Sayısal toplam
                if (group.links && group.links.length > 0) {
                    amountSum = group.links.reduce((sum, link) => {
                        // Gelen string veriyi toplama için sayıya çevir
                        return sum + this.parseTurkishCurrency(link.total_amount);
                    }, 0);
                }
                // -----------------------------------------------------------

                grandTotalLinks += linksCount;
                grandTotalEvents += eventCount;
                grandTotalCarts += cartCount;
                grandTotalOrders += orderCount;
                grandTotalAmount += amountSum;

                // Excel'e yazdırırken:
                // amountSum'ı tekrar "4.150,81" string formatına çeviriyoruz.
                finalData.push([
                    group.influencer_name_surname, linksCount, eventCount, 
                    cartCount, orderCount, this.formatTurkishCurrency(amountSum)
                ]);
            });

            // Genel Toplam satırını ekle (Sayıyı formatlayarak)
            const totalRow = [
                'GENEL TOPLAM', grandTotalLinks, grandTotalEvents, 
                grandTotalCarts, grandTotalOrders, this.formatTurkishCurrency(grandTotalAmount)
            ];
            finalData.push(totalRow);

            const ws = XLSX.utils.aoa_to_sheet(finalData);

            // --- Stiller ve Formatlar ---
            const mergeRange = { s: { r: 0, c: 0 }, e: { r: 0, c: summaryHeaders.length - 1 } };
            if (!ws['!merges']) ws['!merges'] = [];
            ws['!merges'].push(mergeRange);

            const headerStyle = { font: { name: 'Arial', sz: 25, color: { rgb: "FFFFFF" }, bold: true }, alignment: { horizontal: 'center', vertical: 'center', wrapText: true }, fill: { fgColor: { rgb: "0000FF" } } };
            ws['A1'].s = headerStyle;

            const subHeaderStyle = { font: { bold: true, color: { rgb: "000000" } }, alignment: { horizontal: 'center', vertical: 'center' }, fill: { fgColor: { rgb: "CCCCCC" } } };
            for (let i = 0; i < summaryHeaders.length; i++) { const cellAddress = XLSX.utils.encode_cell({ r: 1, c: i }); if (ws[cellAddress]) ws[cellAddress].s = subHeaderStyle; }

            const totalRowStyle = { font: { bold: true, color: { rgb: "000000" } }, alignment: { horizontal: 'right', vertical: 'center' }, fill: { fgColor: { rgb: "FFFF00" } }, border: { top: { style: "thin", color: { rgb: "000000" } } } };
            const lastRowIndex = finalData.length - 1;
            for (let i = 0; i < summaryHeaders.length; i++) {
                const cellAddress = XLSX.utils.encode_cell({ r: lastRowIndex, c: i });
                if (ws[cellAddress]) {
                    ws[cellAddress].s = totalRowStyle;
                    if (i === 0) ws[cellAddress].s = { ...totalRowStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                }
            }
            
            // Tutar sütununu sağa yasla (Artık string olduğu için numFmt kullanmıyoruz, sadece hizalama)
            const amountColumnIndex = 5;
            for (let r = 2; r < finalData.length; r++) { 
                const cellAddress = XLSX.utils.encode_cell({ r: r, c: amountColumnIndex });
                if (ws[cellAddress]) {
                    ws[cellAddress].s = ws[cellAddress].s || {};
                    // Toplam satırı hariç hizalamayı sağa al
                    if (r < finalData.length - 1) {
                         ws[cellAddress].s.alignment = { horizontal: 'right', vertical: 'center' };
                    }
                }
            }

            ws['!cols'] = [ { wch: 30 }, { wch: 15 }, { wch: 25 }, { wch: 20 }, { wch: 20 }, { wch: 25 } ];
            ws['!rows'] = [ { hpx: 40 }, { hpx: 20 } ];
            return ws;
        },

        // Sayfa 2: Detaylı Raporu Oluşturma
        createDetailSheet(groupedLinks) {
            const finalData = [];
            const merges = [];
            let currentRowIndex = 0;

            const selectedLinkTitles = [ 'Fenomen Adı', ...this.selected.map(item => item.title).filter(title => title !== 'Fenomen Adı') ].filter(title => this.linkExcelColumnMap[title] || ['Fenomen Adı'].includes(title));
            const selectedLinkKeys = selectedLinkTitles.map(title => this.linkExcelColumnMap[title] || title);
            
            // Başlıkta TL ibaresini güncelle
            const updatedTitles = selectedLinkTitles.map(title => title === 'Toplam Satış' ? 'Toplam Satış (TL)' : title);
            finalData.push(updatedTitles);
            currentRowIndex++; 

            const grandTotals = {};
            const numericKeysForSum = ['event_count', 'cart_count', 'order_count'];
            const amountKey = 'total_amount';
            [...numericKeysForSum, amountKey].forEach(key => grandTotals[key] = 0);

            for (const group of groupedLinks) {
                const linkRows = group.links.length > 0 ? group.links.length : 1;
                const startRow = currentRowIndex;
                const endRow = currentRowIndex + linkRows - 1;
                
                if (linkRows > 1) merges.push({ s: { r: startRow, c: 0 }, e: { r: endRow, c: 0 } }); 

                if (group.links.length > 0) {
                    for (const link of group.links) {
                        const linkRow = [];
                        linkRow.push((currentRowIndex === startRow) ? (group.influencer_name_surname || 'N/A') : '');
                        
                        selectedLinkKeys.forEach(key => {
                            if (key !== 'influencer_name_surname') {
                                const value = link[key] ?? '';
                                
                                if (key === amountKey) {
                                    // Tutar ise, string formatını koru ama toplama için sayıya çevir
                                    linkRow.push(value); // Orijinal stringi yaz
                                    grandTotals[key] += this.parseTurkishCurrency(value);
                                } else {
                                    // Diğer sayısal alanlar
                                    linkRow.push(value);
                                    if (numericKeysForSum.includes(key)) {
                                        grandTotals[key] += Number(value) || 0;
                                    }
                                }
                            }
                        });
                        finalData.push(linkRow);
                        currentRowIndex++;
                    }
                } else {
                    const emptyRow = [ group.influencer_name_surname || 'N/A', 'Link Yok', ...Array(selectedLinkKeys.length - 2).fill('') ];
                    finalData.push(emptyRow);
                    currentRowIndex++;
                }
            }

            // Genel Toplam Satırı
            const totalRow = [];
            selectedLinkKeys.forEach((key, index) => {
                if (index === 0) {
                    totalRow.push('GENEL TOPLAM');
                } else if (numericKeysForSum.includes(key)) {
                    totalRow.push(grandTotals[key]);
                } else if (key === amountKey) {
                    // Toplam tutarı formatla ve yaz
                    totalRow.push(this.formatTurkishCurrency(grandTotals[key]));
                } else {
                    totalRow.push('');
                }
            });
            finalData.push(totalRow);
            const lastRowIndex = finalData.length - 1;
            
            const ws = XLSX.utils.aoa_to_sheet(finalData); 
            ws['!merges'] = merges;

            const totalRowStyle = { font: { bold: true, color: { rgb: "000000" } }, alignment: { horizontal: 'right', vertical: 'center' }, fill: { fgColor: { rgb: "FFFF00" } }, border: { top: { style: "thin", color: { rgb: "000000" } } } };
            
            for (let i = 0; i < selectedLinkKeys.length; i++) {
                const cellAddress = XLSX.utils.encode_cell({ r: lastRowIndex, c: i });
                if (ws[cellAddress]) {
                    ws[cellAddress].s = totalRowStyle;
                    if (i === 0) ws[cellAddress].s = { ...totalRowStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                }
            }
            
            // Tutar sütununu sağa yasla
            const amountColIndexDetail = selectedLinkKeys.indexOf(amountKey);
            if (amountColIndexDetail > -1) {
                 for (let r = 1; r < finalData.length; r++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: r, c: amountColIndexDetail });
                    if(ws[cellAddress]) {
                        ws[cellAddress].s = ws[cellAddress].s || {};
                         // Toplam satırı hariç hizalamayı sağa al
                        if (r < finalData.length - 1) {
                             ws[cellAddress].s.alignment = { horizontal: 'right', vertical: 'center' };
                        }
                    }
                 }
            }

            const colWidths = updatedTitles.map(title => {
                switch (title) {
                    case 'Fenomen Adı': return { wch: 30 }; case 'Paylaşım Adı': return { wch: 40 }; case 'Paylaşım Link': return { wch: 50 };
                    case 'Oluşturulma Tarihi': return { wch: 20 }; case 'Platform': return { wch: 15 }; case 'Kısa Kod': return { wch: 15 };
                    case 'Tıklanma (Event)': return { wch: 15 }; case 'Sepet (Cart)': return { wch: 15 }; case 'Sipariş (Order)': return { wch: 15 };
                    case 'Toplam Satış (TL)': return { wch: 20 }; default: return { wch: 20 };
                }
            });
            ws['!cols'] = colWidths;

            return ws;
        },

        // Ana indirme ve çoklu sayfa oluşturma metodu
        async createGroupedLinkExcel(response) {
            const groupedLinks = response.data.groupedLinks;
            
            if (!groupedLinks || groupedLinks.length === 0) {
                this.$toast.error('Bu filtreler için geçerli link verisi bulunamadı.');
                return;
            }

            // 1. Sayfaları oluştur
            const summarySheet = this.createSummarySheet(groupedLinks);
            const detailSheet = this.createDetailSheet(groupedLinks);
            
            const wb = XLSX.utils.book_new();
            
            // 2. Sayfaları Kitaba Ekle
            XLSX.utils.book_append_sheet(wb, summarySheet, 'Özet Rapor');
            XLSX.utils.book_append_sheet(wb, detailSheet, 'Detaylı Rapor');
            
            // 3. Dosya Adını Oluştur (Tarihler prop'tan geliyor)
            const startDateStr = this.rangeDateProps.start_date || 'BaşlangıçYok';
            const endDateStr = this.rangeDateProps.end_date || 'BitişYok';
            const fileName = `Fenomany-Fenomen_RAPORU_${startDateStr}_${endDateStr}.xlsx`;
            
            // 4. Dosyayı indir
            // Stil kütüphanesi kullanıyorsanız write işlemi biraz farklı olabilir,
            // ancak writeFile genellikle kütüphane tarafından doğru yönetilir.
            XLSX.writeFile(wb, fileName);
            
            this.progress = 100;
            this.$toast({
                component: ToastificationContent,
                position: 'bottom-right',
                props: {
                    icon: 'CheckIcon',
                    variant: 'success',
                    title: "İndirme işlemi başarılı",
                },
            });
        },

        // Tek sayfa rapor oluşturma (Paylaşım Analizi için)
        createSingleSheetExcel(response) {
            const links = response.data.links; // Backend'den düz liste geliyor
            
            if (!links || links.length === 0) {
                this.$toast.error('Bu filtreler için geçerli link verisi bulunamadı.');
                return;
            }

            const wb = XLSX.utils.book_new();
            let currentRowIndex = 0;

            const selectedLinkTitles = this.selected.map(item => item.title).filter(title => this.linkExcelColumnMap[title]);
            const selectedLinkKeys = selectedLinkTitles.map(title => this.linkExcelColumnMap[title]);
            // --- 2. Ana Başlığı Hazırla (YENİ EKLENDİ) ---
            const startDateStr = this.formatDateForHeader(this.rangeDateProps.start_date);
            const endDateStr = this.formatDateForHeader(this.rangeDateProps.end_date);
            let reportTypeName = Array.isArray(this.reportType) ? this.reportType.join('_') : (this.reportType || 'Paylasim');
            
            if(reportTypeName=='influencer') reportTypeName='Paylaşım';
            if(reportTypeName=='story') reportTypeName='Story Paylaşımı';
            if(reportTypeName=='sms') reportTypeName='Sms Paylaşımı';   
            const mainHeaderTitle = `${startDateStr} - ${endDateStr} Tarihleri Arasındaki ${reportTypeName} Analizi`;
            const finalData = [ [mainHeaderTitle] ]; // İlk satır ana başlık
            currentRowIndex++;

            // --- 3. Sütun Başlıklarını Hazırla ---
            // Başlıkta TL ibaresini güncelle
            const updatedTitles = selectedLinkTitles.map(title => title === 'Toplam Satış' ? 'Toplam Satış (TL)' : title);
            finalData.push(updatedTitles); // İkinci satır sütun başlıkları
            currentRowIndex++;

            // Genel Toplamlar için değişkenler
            const grandTotals = {};
            const numericKeysForSum = ['event_count', 'cart_count', 'order_count'];
            const amountKey = 'total_amount';
            [...numericKeysForSum, amountKey].forEach(key => grandTotals[key] = 0);

            // --- 4. Verileri Hazırla ---
            for (const link of links) {
                const linkRow = [];
                selectedLinkKeys.forEach(key => {
                    // Backend'den sayısal olarak gelen değerleri al
                    const value = link[key] ?? '';
                    
                    if (key === amountKey) {
                        // Tutar ise, formatlayarak string olarak yaz ama toplama için ham değeri kullan
                        linkRow.push(this.formatTurkishCurrency(value));
                        grandTotals[key] += (Number(value) || 0);
                    } else {
                        // Diğer sayısal alanlar
                        linkRow.push(value);
                        if (numericKeysForSum.includes(key)) {
                            grandTotals[key] += Number(value) || 0;
                        }
                    }
                });
                finalData.push(linkRow);
                currentRowIndex++;
            }

            // --- 5. Genel Toplam Satırını Hazırla ---
            const totalRow = [];
            selectedLinkKeys.forEach((key, index) => {
                if (index === 0) {
                    totalRow.push('GENEL TOPLAM');
                } else if (numericKeysForSum.includes(key)) {
                    totalRow.push(grandTotals[key]);
                } else if (key === amountKey) {
                    totalRow.push(this.formatTurkishCurrency(grandTotals[key]));
                } else {
                    totalRow.push('');
                }
            });
            finalData.push(totalRow);

            // Veriyi sayfaya dönüştür
            const ws = XLSX.utils.aoa_to_sheet(finalData); 

            // --- 6. HÜCRE BİRLEŞTİRME (Ana Başlık İçin) (YENİ EKLENDİ) ---
            const mergeRange = { s: { r: 0, c: 0 }, e: { r: 0, c: selectedLinkTitles.length - 1 } };
            if (!ws['!merges']) ws['!merges'] = [];
            ws['!merges'].push(mergeRange);

            // --- 8. SÜTUN GENİŞLİKLERİ VE SATIR YÜKSEKLİKLERİ (YENİ EKLENDİ) ---
            const colWidths = updatedTitles.map(title => {
                switch (title) {
                    case 'Paylaşım Adı': return { wch: 40 };
                    case 'Paylaşım Link': return { wch: 50 };
                    case 'Oluşturulma Tarihi': return { wch: 22 };
                    case 'Platform': return { wch: 15 };
                    case 'Kısa Kod': return { wch: 15 };
                    case 'Tıklanma (Event)': return { wch: 18 };
                    case 'Sepet (Cart)': return { wch: 18 };
                    case 'Sipariş (Order)': return { wch: 18 };
                    case 'Toplam Satış (TL)': return { wch: 25 };
                    default: return { wch: 20 };
                }
            });
            ws['!cols'] = colWidths;
            // Ana başlık yüksek, sütun başlıkları normal
            ws['!rows'] = [{ hpx: 40 }, { hpx: 20 }]; 

            // Sayfayı Kitaba Ekle
            XLSX.utils.book_append_sheet(wb, ws, 'Paylaşım Raporu');
            
            // Dosya Adını Oluştur ve İndir
            const fileName = `Fenomany-${reportTypeName}_RAPORU_${startDateStr}_${endDateStr}.xlsx`;
            
            XLSX.writeFile(wb, fileName);
            
            this.progress = 100;
            this.$toast({ component: ToastificationContent, position: 'bottom-right', props: { icon: 'CheckIcon', variant: 'success', title: "İndirme işlemi başarılı", }, });
        },


        async startDownload() {
            this.isLoading = true;
            this.progress = 0;
            this.error = null;

            // --- GÜNCELLEME: reportType'a göre URL ve Parametreleri belirle ---
            // reportType null değilse (örn: 'story', 'post' veya bunların dizisi) Paylaşım Raporu'dur.
            const isPostReport = this.reportType !== null && this.reportType !== undefined;
            
            const endpointUrl = isPostReport 
                ? '/download/linkExcel' // Yeni endpoint (Paylaşım Analizi)
                : '/download/influencerLinkExcel'; // Mevcut endpoint (Fenomen Analizi)

            const requestParams = {
                ...this.rangeDateProps
            };

            if (isPostReport) {
                requestParams.type = this.reportType; // Tip filtresini ekle
            }
            // -----------------------------------------------------------------

            try {
                // İlerleme çubuğunu başlat
                const progressInterval = setInterval(() => {
                    if (this.progress < 90) this.progress += 10;
                }, 500);

                const response = await axiosIns({
                    method: 'GET',
                    url: endpointUrl, // Belirlenen URL'i kullan
                    responseType: 'json',
                    params: requestParams, // Belirlenen parametreleri kullan
                });

                clearInterval(progressInterval); // API yanıt verince intervali durdur
                this.progress = 95; // Dosya oluşturma aşamasına geçildiğini göster

                // --- GÜNCELLEME: reportType'a göre uygun Excel oluşturma fonksiyonunu çağır ---
                if (isPostReport) {
                    // Tek sayfalık rapor (Paylaşım Analizi)
                    this.createSingleSheetExcel(response);
                } else {
                    // İki sayfalık rapor (Fenomen Analizi)
                    await this.createGroupedLinkExcel(response);
                }
                // -----------------------------------------------------------------------------
                
            } catch (err) {
                console.error("Excel indirme hatası:", err);
                this.$toast.error('Dosya oluşturulurken hata oluştu. Lütfen tekrar deneyin. Hata: ' + (err.response?.data?.message || err.message));
            } finally {
                this.isLoading = false;
                // Başarılı olsa da olmasa da progress'i sıfırla ve popover'ı kapat
                setTimeout(() => {
                    this.progress = 0;
                    this.$emit('popoverShow', false);
                }, 1000);
            }
        },
        fenomenNameControl() {
          let newSelected = [];
          let newOption = [];
          let newMap = {};

          const isPostReport = this.reportType !== null && this.reportType !== undefined;

          // TÜM kampanya türlerini burada listele (çiftlenmeyi önleyen kısım)
          const allCampaignTypes = [
              'Paylaşım Adı', 
              'Whatsapp Adı', 
              'Sms Adı', 
              'Story Adı', 
              'Post Adı', 
              'Bio Adı',
              'Video Adı',
              'Reels Adı',
              'Tiktok Adı',
              'Kampanya Adı', 
              this.currentReportTypeName // seçili olan da dahil
          ];

          // --- 1) Eski dinamik kolonları temizle ---
          this.selected = this.selected.filter(item => 
              item.title !== 'Fenomen Adı' &&
              !allCampaignTypes.includes(item.title)
          );

          this.option = this.option.filter(item => 
              item.title !== 'Fenomen Adı' &&
              !allCampaignTypes.includes(item.title)
          );

          delete this.linkExcelColumnMap['Fenomen Adı'];
          allCampaignTypes.forEach(t => delete this.linkExcelColumnMap[t]);

          // --- 2) Gereken kolonları ekle ---
          if (!isPostReport || this.reportType === 'influencer') {
              newSelected.push({ title: 'Fenomen Adı' });
              newOption.push({ title: 'Fenomen Adı' });
              newMap['Fenomen Adı'] = 'influencer_name_surname';
          }

          if (this.currentReportTypeName) {
              newSelected.push({ title: this.currentReportTypeName });
              newOption.push({ title: this.currentReportTypeName });
              newMap[this.currentReportTypeName] = 'campaign_name';
          }

          // --- 3) Başa ekle ---
          this.selected = [...newSelected, ...this.selected];
          this.option = [...newOption, ...this.option];
          this.linkExcelColumnMap = { ...newMap, ...this.linkExcelColumnMap };
      }


    },
    created() {
      this.fenomenNameControl();
    },
    computed: {
      currentReportTypeName() {
        if (this.reportType && this.reportType !== 'influencer') {
          const typeStr = Array.isArray(this.reportType) ? this.reportType[0] : this.reportType;
          if (typeStr) {
              return typeStr.charAt(0).toUpperCase() + typeStr.slice(1) + ' Adı';
          }
        }
        return 'Paylaşım Adı';
      },
    },
    watch: {
      '$route.params.type'(newVal, oldVal) {
        this.reportType = newVal || null;
        this.fenomenNameControl();
      }
    }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.selected-row {
  background-color: #d1e7dd !important; /* Açık yeşil arka plan */
}
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.per-page-selector {
  width: 90px;
}
.fixed-bottom {
  margin-bottom: 4vw; /* Toast'ın alt kısımdaki yüksekliği */
}
.text-center {
  text-align: center; /* Yazıyı ortalamak için */
}
.vs__deselect svg{
  fill: #FFF;
}
</style>